var Item;

Item = function(self) {
  Observable(self, 'updating', false);
  Observable(self, 'updated', false);
  self.api = function() {
    return api.assets.items;
  };
  Editable(self, 'width', (function(_this) {
    return function() {
      return self.update({
        width: self.width()
      });
    };
  })(this));
  Editable(self, 'height', (function(_this) {
    return function() {
      return self.update({
        height: self.height()
      });
    };
  })(this));
  Editable(self, 'price', (function(_this) {
    return function() {
      return self.update({
        price: self.price()
      });
    };
  })(this));
  Editable(self, 'amount_available', (function(_this) {
    return function() {
      return self.update({
        amount_available: self.amount_available()
      });
    };
  })(this));
  self.update = (function(_this) {
    return function(data, callback) {
      if (data == null) {
        return;
      }
      self.updating(true);
      self.updated(false);
      return self.api().update(self.asset_id, self.id, data).done(function(response) {
        if (callback != null) {
          callback(response);
        }
        self.updating(false);
        return self.updated(true);
      });
    };
  })(this);
  self["delete"] = (function(_this) {
    return function(callback) {
      return self.api().destroy(self.asset_id, self.id).done(callback);
    };
  })(this);
  return self;
};

if (api.assets == null) {
  api.add('assets');
}

api.assets.add('items');

Item.find = function(asset_id, callback) {
  return api.assets.items.read(asset_id).done(callback);
};

Item.create = function(asset_id, options, callback) {
  return api.assets.items.create(asset_id, options).done(callback);
};

//# sourceMappingURL=item.js.map
